export default "__VITE_ASSET__Depssr_8__"